import React, { Component } from 'react'
import Navbar from './Navbar'
import '../styles/Hero.css'
import BackgroundJpg from '../images/Landing/hero.jpg'
import BackgroundWebp from '../images/Landing/hero.webp'
import EscapeGameTitle from '../images/Landing/escape-signature.png'
import ScrollableAnchor from 'react-scrollable-anchor'
import { injectIntl, defineMessages } from "react-intl"
import { Parallax } from 'react-scroll-parallax'

const messages = defineMessages({
  discoverOurThemes: {
    id: 'hero.discoverOurThemes',
    defaultMessage: 'Découvrez nos thèmes escape game à Paris'
  },
  baseline: {
    id: 'hero.baseline',
    defaultMessage: 'Venez vivre une expérience immersive inédite'
  }
})

class Hero extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTop: true
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
        this.setState({ isTop })
      }
    })
  }
  render() {
    const { intl: { formatMessage } } = this.props
    return (
      <div className='hero'>
        <picture>
          <source srcSet={BackgroundWebp} type="image/webp" />
          <img
            className="hero-bg"
            src={BackgroundJpg}
            alt=""
            fetchpriority="high"
            width={1920}
            height={1080}
            aria-hidden="true"
            tabIndex={-1}
          />
        </picture>
        <div className="hero-content">
          <Navbar
            isTop={this.state.isTop}
            lang={this.props.lang}
            handleLang={(lang) => this.props.handleLang(lang)}
          />
          <div className="hero-title">
            <h2>{formatMessage(messages.baseline)}</h2>
            <h3>One Hour</h3>
            <Parallax
              offsetYMax={-50}
              offsetYMin={50}
              slowerScrollRate
            >
              <img className="escape-game-title" src={EscapeGameTitle} loading="lazy" alt="Escape Game Paris" />
            </Parallax>
          </div>
          <ScrollableAnchor id="themes">
            <div id="themes" className="discover-our-themes">
              <h1>{formatMessage(messages.discoverOurThemes)}</h1>
            </div>
          </ScrollableAnchor>
        </div>
      </div>
    )
  }
}

export default injectIntl(Hero)


// WEBPACK FOOTER //
// ./src/components/Hero.js